module.exports = __webpack_public_path__ + "img/slider_7.eaab2f4c.jpg";